import { MxAutoCompleteFieldProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
import { useMxFieldControllerContext } from "../../../../context/MxFieldController";
import MxSelectImprovementsField from "@rf-l1/form/selects/MxSelectImprovementsField";
type omit = "value" | "id" | "name" | "testId" | "items" | "onChange";

export type MxFormSelectImprovementsFieldProp = Omit<MxAutoCompleteFieldProps, omit>;

const MxFormSelectImprovementsField = (props: MxFormSelectImprovementsFieldProp) => {
  const { onChange, onBlur, name, value, invalid, id, testId, inputRef } =
    useMxFieldControllerContext();

  return (
    <MxSelectImprovementsField
      {...props}
      id={id}
      testId={testId}
      inputRef={inputRef}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      value={value}
      error={invalid}
    />
  );
};

export default MxFormSelectImprovementsField;
